/* eslint-env es2023 */
function getCookieByNameOb(name) {
    function escape(s) {
      return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1')
    }
    var match = document.cookie.match(
      RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)')
    )
    return match ? match[1] : null
  }
  
  function setCookieOb(cname, cvalue, exdays) {
    const d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    let expires = 'expires=' + d.toUTCString()
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
  }
  
  function updateLocalizationOb({ country, language }) {
    const formId = crypto.randomUUID()
    const formHtml = `
        <form id="${formId}" action="/localization" method="POST" hidden>
          <input name="_method" value="PUT">
          <input name="country_code" value="${country}">
          <input name="language_code" value="${language}">
        </form>
      `
    document.body.insertAdjacentHTML('beforeend', formHtml)
    document.getElementById(formId).submit()
  }
  
  async function detectObCountry() {
    if (window.Shopify.designMode) {
      console.log('[OB] Design mode detected, skipping country detection')
      return
    }
  
    console.log('[OB] Detecting Country')
  
    const obCountryDetectionCookieName = 'ob-localization'
  
    try {
      const localizationCountry = getCookieByNameOb(obCountryDetectionCookieName)
  
      console.log(
        '[OB] Detected Cookie: ',
        localizationCountry || 'No cookie detected'
      )
  
      if (localizationCountry) {
        return
      }
  
      const shopifyDetectResponse = await fetch(
        window.Shopify.routes.root +
          'browsing_context_suggestions.json' +
          '?country[enabled]=true' +
          `&country[exclude]=${window.Shopify.country}` +
          '&language[enabled]=true' +
          `&language[exclude]=${window.Shopify.language}`
      ).then(r => r.json())
  
      const suggestedCountry =
        shopifyDetectResponse.detected_values?.country?.handle
      const suggestedLanguage =
        shopifyDetectResponse.suggestions?.[0]?.parts?.language?.handle ||
        window.Shopify.locale
  
      if (!suggestedCountry || !suggestedLanguage) {
        return
      }
  
      console.log(
        '[OB] Suggested Country and Language: ',
        suggestedCountry,
        suggestedLanguage
      )
      setCookieOb(obCountryDetectionCookieName, 'true', 365)
  
      if (suggestedCountry != window.Shopify.country) {
        updateLocalizationOb({
          country: suggestedCountry,
          language: suggestedLanguage,
        })
      }
    } catch (error) {
      console.error('Error fetching user country: ', error)
    }
  }
  